<template>
    <div class="pfs-curveplot">
      <div style="width: 70%; margin: 10px; background: #ebebeb; padding: 20px;">
        Select variable on the left to generate a PFS survival curve.
      </div>
      <div :id="divId">
      </div>
    </div>
  </template>
  
  <script>
  import pfscurveplot from '../../plotly/pfscurveplotly'
  import trackDetailsPTRC from '../../refs/trackDetails'
  import trackDetailsPCC from '../../refs/trackDetailsPCC'

  export default {
      name: "pfs-curveplot",

      props: ['studySelected'],

  
      data: () => ({
      }),
      
      computed: {
        divId() { return 'pfs-curveplotly' },
        // trackA() { return this.trackData[this.tracks[0]] },
        // trackB() { return this.trackData[this.tracks[1]] },
        trackDetails() { 
          if (this.studySelected === 'PCC') {
            return trackDetailsPCC
          } else {
            return trackDetailsPTRC
          }
        },
        varName() { 
          console.log('varName PfsCurveplot.vue', this.$store.state.PfsCurveplot_varName)
          return this.$store.state.PfsCurveplot_varName
        },
        threshold() { 
          console.log('threshold PfsCurveplot.vue', this.$store.state.PfsCurveplot_contThresh)
          return this.$store.state.PfsCurveplot_contThresh 
        },
        varOmics() { 
          console.log('varOmics PfsCurveplot.vue', this.$store.state.PfsCurveplot_varOmics)
          return this.$store.state.PfsCurveplot_varOmics 
        },
        varType() { 
          console.log('varType PfsCurveplot.vue', this.$store.state.PfsCurveplot_varType)
          return this.$store.state.PfsCurveplot_varType 
        },
        pfsData() { 
            console.log('pfsData PfsCurveplot.vue', this.$store.state.PfsCurveplot_data)
            return this.$store.state.PfsCurveplot_data },
        cohortSelected() { 
            console.log('cohortSelected PfsCurveplot.vue', this.$store.state.PfsCurveplot_cohortSelected)
            return this.$store.state.PfsCurveplot_cohortSelected },

        overallCurve() {
          console.log('overallCurve PfsCurveplot.vue', this.$store.state.PfsCurveplot_overallCurve)
          return this.$store.state.PfsCurveplot_overallCurve
        }
        // tracks() { return this.$store.state.Scatterplot_tracks },
        // useZScore() { return this.$store.state.Scatterplot_useZScore },
        // trackDataNormalized() { return this.$store.state.Scatterplot_data },
        // trackDataRaw() { return this.$store.state.Scatterplot_data_raw },
        // trackData() { return this.useZScore ? 
        //   this.trackDataNormalized 
        //   : this.trackDataRaw 
        // },
      },
  
      watch: {
        varType() { this.renderPfsCurveplot() },
        varName() { this.renderPfsCurveplot() },
        pfsData() { this.renderPfsCurveplot() },
        threshold() { this.renderPfsCurveplot() },
        varOmics() { this.renderPfsCurveplot() },
        cohortSelected() { this.renderPfsCurveplot() },
        trackDetails() {this.renderPfsCurveplot()},
        studySelected() { this.renderPfsCurveplot() },
        overallCurve() { this.renderPfsCurveplot() },
      },
  
      methods: {
        renderPfsCurveplot() {
           pfscurveplot({
            divId: this.divId,
            varName: this.varName,
            threshold: this.threshold,
            pfsData: this.pfsData,
            varOmics: this.varOmics,
            varType: this.varType,
            trackDetails: this.trackDetails,
            cohortSelected: this.cohortSelected,
            studySelected: this.studySelected,
            overallCurve: this.overallCurve
          })
        },
      },
  
      mounted() {
  
      },
    }
  </script>
  
  <style>
  .pfs-curveplot {
      width: 100%;
      height: 200%;
      aspect-ratio: 1;
      display: flex;
      flex-direction: column;
      /* margin: 10px; */
      /* padding-left: 10px; */
      overflow: scroll; /* Direct aspect ratio control */
  
  }
  .pfs-curveplotly {
      width: 100%;
      height: 200%;
      aspect-ratio: 1;
      display: flex;
      flex-direction: column;
      /* margin: 10px; */
      /* padding-left: 10px; */
      overflow: scroll; /* Direct aspect ratio control */
  
  }
  </style>